// extracted by mini-css-extract-plugin
export default {"formItemHidden":"formItemHidden__aOc2EY","switch":"switch__DZl_vP"};